var i18n;

try {
    i18n = require('live/services/i18n');
}
catch (e) {
    i18n = () => {};
}

export default i18n;
